import $ from 'jquery';
import {alterDirector} from './diretor/form';
import {alterRepresentatives} from './representante/form';

function cadastrarEstabelecimento(form) {
  const args = $(form).serialize();
  Promise.resolve($.post("?acao=cadastrar", args))
    .then(resp => {   
      console.log(resp);   
      if (resp.sucesso == "true") {
        sisSetAlert("true", "Estabelecimento criado, agora voce pode informar o Diretor e Representantes");

        return resp;
      } 
      throw new Error(resp.retorno);
    })
    .then((resp) => Promise.resolve($.getJSON("?acao=alterar", {sisReg: [resp.estabelecimentoId]})))
    .then(alterResp => $("#sisContainerManu").html(alterResp.retorno))
    .then(sisFiltrarPadrao)
    .catch((err) => sisSetAlert("false", err));
}

export default {
  alterDirector,
  alterRepresentatives,
  cadastrarEstabelecimento
}



// WEBPACK FOOTER //
// ./resources/js/estabelecimento.js